import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: ${props => (props.height ? props.height : '400px')};

  background: ${({ theme }) => theme.colors.primary};

  position: absolute;
  top: 0;

  z-index: 0;
`;
